import { createContext } from "react";

const index = process.env["REACT_APP_ALGOLIA_INDEX"];

export const IndexContext = createContext<{ index: string; setIndex: any }>({
  index: index || "",
  setIndex: (value : string) => {},
});
